import React from 'react';
import PropTypes from 'prop-types';

import { SearchBar } from '@metarouter-private/mr-mui';

import { useBulkDeployPageContext } from '../../BulkDeployPageContext';

export default function BulkDeploySearchBar({ disabled }) {
  const { searchTerm, setSearchTerm } = useBulkDeployPageContext();

  return (
    <SearchBar
      variant="outlined"
      placeholder="Filter by Name or Writekey..."
      size="small"
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
      disabled={disabled}
      data-test-id="bulkDeploySearchBar"
    />
  );
}

BulkDeploySearchBar.propTypes = {
  disabled: PropTypes.bool,
};
